import React from "react";
import { Check, X, Minus } from "lucide-react";

const V = {
  yes:   <Check size={16} style={{ color: "#0A7A2C" }}/>,
  no:    <X size={16} style={{ color: "#8a2020" }}/>,
  some:  <Minus size={16} style={{ color: "var(--mv-muted)" }}/>,
};

const COLS = [
  { key: "bank",     label: "Bank savings" },
  { key: "stocks",   label: "UK stocks" },
  { key: "gold",     label: "Gold" },
  { key: "crypto",   label: "Crypto" },
  { key: "schemes",  label: "Other African schemes" },
  { key: "mavula",   label: "MAVULA", highlight: true },
];

const ROWS = [
  { label: "Real, physical asset",           bank: "no",  stocks: "no",   gold: "yes", crypto: "no",  schemes: "some", mavula: "yes" },
  { label: "Title deed in your own name",    bank: "no",  stocks: "no",   gold: "no",  crypto: "no",  schemes: "some", mavula: "yes" },
  { label: "Passable to your heirs",         bank: "some",stocks: "yes",  gold: "yes", crypto: "some",schemes: "some", mavula: "yes" },
  { label: "Requires visa/immigration status",bank: "no", stocks: "yes",  gold: "no",  crypto: "no",  schemes: "some", mavula: "no"  },
  { label: "Independent legal oversight",    bank: "yes", stocks: "yes",  gold: "no",  crypto: "no",  schemes: "some", mavula: "yes" },
  { label: "Predictable long-term returns",  bank: "some",stocks: "no",   gold: "no",  crypto: "no",  schemes: "no",   mavula: "yes" },
  { label: "Cooling-off + buy-back",         bank: "yes", stocks: "no",   gold: "no",  crypto: "no",  schemes: "no",   mavula: "yes" },
  { label: "Impact on the community",        bank: "no",  stocks: "no",   gold: "no",  crypto: "no",  schemes: "some", mavula: "yes" },
];

export default function ComparisonMatrix() {
  return (
    <section className="py-14 md:py-20" data-testid="comparison-matrix">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Where MAVULA fits</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          Compared to <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>everything else.</span>
        </h2>
        <p className="mt-3 max-w-2xl text-[14.5px]" style={{ color: "var(--mv-muted)" }}>
          Not the flashiest option. Not the riskiest. The mature, dignified middle — with a title deed at the end.
        </p>

        <div className="mt-8 overflow-x-auto mv-card">
          <table className="w-full text-[13.5px]">
            <thead>
              <tr className="text-left border-b mv-hairline" style={{ color: "var(--mv-muted)" }}>
                <th className="py-3 px-4 text-[11.5px] uppercase tracking-[0.16em]">Feature</th>
                {COLS.map((c) => (
                  <th key={c.key}
                      className={`py-3 px-4 text-[11.5px] uppercase tracking-[0.16em] ${c.highlight ? "mv-green-text font-semibold" : ""}`}>
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={i} className="border-b mv-hairline" data-testid={`comp-row-${i}`}>
                  <td className="py-3 px-4">{r.label}</td>
                  {COLS.map((c) => (
                    <td key={c.key}
                        className={`py-3 px-4 ${c.highlight ? "bg-[color:var(--mv-gold)]/[0.10]" : ""}`}>
                      {V[r[c.key]] || V.some}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-4 text-[11.5px] font-accent italic" style={{ color: "var(--mv-muted)" }}>
          Indicative comparison based on general market conditions. Individual products and jurisdictions vary — always take independent advice.
        </p>
      </div>
    </section>
  );
}
